import React, { Fragment } from 'react'
import { Statistic } from 'semantic-ui-react'
import { formatDollar } from '../../../utils/helpers'
import ExpertTags from '../ExpertTags'

const DefaulCard = ({ expert }) => {
    return (
        <Fragment>
            <Statistic.Group widths={4}>
                <Statistic horizontal>
                    <Statistic.Value>
                        {formatDollar(expert.expert.hourlyRate)}
                    </Statistic.Value>
                    <Statistic.Label>/ hr</Statistic.Label>
                </Statistic>
                <Statistic horizontal>
                    <Statistic.Value>
                        {expert.expert.responseRate}%
                    </Statistic.Value>
                    <Statistic.Label>Response Rate</Statistic.Label>
                </Statistic>
                <Statistic horizontal>
                    <Statistic.Value>
                        {expert.expert.numCompleted}
                    </Statistic.Value>
                    <Statistic.Label>Total Engagements</Statistic.Label>
                </Statistic>
            </Statistic.Group>
            <ExpertTags expert={expert} showInternalOnly={false} />
        </Fragment>
    )
}

export default DefaulCard
